// ./layouts/user/UserProfile.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ShopNav from "../../../components/shopNav/ShopNav";
import NavCategorias from "../../../components/navbar/NavCategorias";
import Footer from "../../../components/footer/footer";
import "./UserProfile.css";
import { FaUser, FaSignOutAlt, FaMapMarkerAlt, FaCog, FaBoxOpen } from "react-icons/fa";

const API_URL = import.meta.env.VITE_API_URL;

const UserProfile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [shippingData, setShippingData] = useState(null);

  // Modales de contraseña
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Función para formatear moneda
  const formatCurrency = (value) =>
    Number(value).toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    });

  // Cargar usuario y dirección
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const u = JSON.parse(storedUser);
      setUser(u);
      fetch(`${API_URL}/checkout/shipping?userId=${u.id}`)
        .then((res) => res.json())
        .then((data) => setShippingData(data))
        .catch((err) => console.error("Error al obtener dirección:", err));
    }
  }, []);

  // Cambio de contraseña
  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) {
      alert("Las contraseñas no coinciden.");
      return;
    }
    try {
      const res = await fetch(`${API_URL}/authStore/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          currentPassword,
          newPassword,
        }),
      });
      const result = await res.json();
      if (res.ok) {
        alert("Contraseña actualizada correctamente.");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setShowPasswordModal(false);
      } else {
        alert(result.message || "No se pudo actualizar la contraseña.");
      }
    } catch (err) {
      console.error(err);
      alert("Error al actualizar la contraseña.");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  if (!user) return null;

  return (
    <div className="user-profile-page">
      <ShopNav />
      <NavCategorias />

      <main className="user-profile-main">
        <section className="user-profile-hero user-profile-elevated-wrap user-profile-elevated-wrap--hero">
          <div className="container user-profile-hero-inner">
            <div className="user-profile-hero-copy">
              <h1 className="display-5">Mi Cuenta</h1>
              <p className="lead">
                Gestiona tus datos, revisa tus pedidos y configura tu cuenta en un solo lugar.
              </p>
            </div>
            <div className="user-profile-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="user-profile-hero-logo" />
            </div>
          </div>
        </section>

        <section className="container user-profile-content">
          <div className="row g-4 user-profile-grid">
            <div className="col-lg-4">
              <div className="card border-0 user-profile-card user-profile-card--sidebar h-100">
                <div className="card-body text-center user-profile-card-body">
                  <div className="user-avatar-ring">
                    <FaUser size={54} />
                  </div>
                  <h4 className="user-name">{user.name || "Usuario"}</h4>
                  <p className="user-email">{user.email}</p>

                  <div className="user-profile-side-actions">
                    <button
                      className="btn btn-outline-danger w-100 user-profile-logout-btn"
                      onClick={handleLogout}
                    >
                      <FaSignOutAlt className="me-2" /> Cerrar sesión
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="card border-0 user-profile-card mb-4">
                <div className="card-header user-profile-card-header d-flex align-items-center">
                  <FaBoxOpen className="me-2" />
                  <h5 className="m-0">Historial de pedidos</h5>
                </div>
                <div className="card-body user-profile-card-body">
                  <button
                    className="btn btn-success user-profile-cta w-100 d-flex align-items-center justify-content-center gap-2"
                    onClick={() => navigate("/mi-cuenta/pedidos")}
                  >
                    <FaBoxOpen /> Ver historial completo
                  </button>
                </div>
              </div>

              <div className="card border-0 user-profile-card mb-4">
                <div className="card-header user-profile-card-header d-flex align-items-center">
                  <FaMapMarkerAlt className="me-2" />
                  <h5 className="m-0">Dirección de envío</h5>
                </div>
                <div className="card-body user-profile-card-body">
                  <div className="shipping-grid">
                    <p><strong>Nombre:</strong> {shippingData?.nombre || "N/D"}</p>
                    <p><strong>Ciudad:</strong> {shippingData?.ciudad || "N/D"}</p>
                    <p><strong>Departamento:</strong> {shippingData?.departamento || "N/D"}</p>
                    <p><strong>Dirección:</strong> {shippingData?.direccion || "N/D"}</p>
                    <p><strong>Teléfono:</strong> {shippingData?.telefono || "N/D"}</p>
                    <p><strong>Email:</strong> {shippingData?.email || "N/D"}</p>
                    <p><strong>Código Postal:</strong> {shippingData?.zip || "N/D"}</p>
                  </div>
                </div>
              </div>

              <div className="card border-0 user-profile-card">
                <div className="card-header user-profile-card-header d-flex align-items-center">
                  <FaCog className="me-2" />
                  <h5 className="m-0">Configuración</h5>
                </div>
                <div className="card-body user-profile-card-body">
                  <button
                    className="btn btn-outline-light user-profile-config-btn"
                    onClick={() => setShowPasswordModal(true)}
                  >
                    Cambiar contraseña
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Modal Cambiar Contraseña */}
      {showPasswordModal && (
        <div className="user-password-backdrop" onClick={() => setShowPasswordModal(false)}>
          <div className="modal-dialog user-password-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content user-password-content">
              <div className="modal-header user-password-header text-white">
                <h5 className="modal-title user-password-title">Cambiar Contraseña</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPasswordModal(false)}
                ></button>
              </div>
              <div className="modal-body user-password-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Actual</label>
                    <input
                      type="password"
                      className="form-control"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nueva</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Confirmar</label>
                    <input
                      type="password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer user-password-footer">
                <button
                  className="btn user-password-cancel-btn"
                  onClick={() => setShowPasswordModal(false)}
                >
                  Cancelar
                </button>
                <button className="btn user-password-save-btn" onClick={handlePasswordChange}>
                  Guardar cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
